<template>
    <div>
        <div class="row">
            <div class="column small-7">
                <PageTitle title="Kortingen" :total="total" :loading="loading" />
            </div>
            <div class="column small-5 text-right">
                <b-button tag="router-link" :to="{ name: 'DiscountsRecord', params: {id: 'nieuw'} }" type="is-dark">Nieuw</b-button>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <b-table
                    :data="records"
                    :striped="true"
                    :loading="loading"
                    :mobile-cards="true"

                    backend-pagination
                    :total="total"
                    :per-page="perPage"
                    @page-change="onPageChange"
                    backend-sorting
                    :default-sort-direction="sortOrder"
                    :default-sort="[sortField, sortOrder]"
                    @sort="onSort"

                    :paginated="paginated"
                    :sort-icon="'chevron-up'"
                >
                    <template>
                        <b-table-column v-slot="props" field="name" label="Naam" sortable>
                            <router-link :to="{ name: 'DiscountsRecord', params: { id: props.row.id } }">
                                <strong>{{ props.row.name }}</strong>
                            </router-link>
                            <div v-if="props.row.description" class="has-text-grey is-size-7">
                                {{ props.row.description }}
                            </div>
                        </b-table-column>

                        <b-table-column v-slot="props" label="Kortingen" width="300">
                            <div v-if="props.row.discounts && props.row.discounts.length > 0">
                                <div v-if="props.row.discounts.length === 1">
                                    <b-tag :type="props.row.discounts[0].type === 'percentage' ? 'is-info' : 'is-warning'">
                                        {{ getDiscountDisplay(props.row.discounts[0]) }} (alle facturen)
                                    </b-tag>
                                </div>
                                <div v-else>
                                    <b-tag v-for="(discount, index) in props.row.discounts" :key="index"
                                           :type="discount.type === 'percentage' ? 'is-info' : 'is-warning'"
                                           style="margin-right: 5px; margin-bottom: 5px;">
                                        {{ index + 1 }}e:&nbsp;{{ getDiscountDisplay(discount) }}
                                    </b-tag>
                                </div>
                            </div>
                            <span v-else class="has-text-grey">Geen kortingen</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="active" label="Status" width="120" sortable>
                            <b-tag
                                :type="props.row.active ? 'is-success' : 'is-danger'"
                                style="cursor: pointer;"
                                @click="toggleActive(props.row)"
                            >
                                {{ props.row.active ? 'Actief' : 'Inactief' }}
                            </b-tag>
                        </b-table-column>

                        <b-table-column v-slot="props" field="updated_at" label="Laatst gewijzigd" width="180" sortable>
                            <span>{{ props.row.updated_at|humanDate }}</span>
                        </b-table-column>

                        <b-table-column v-slot="props" numeric width="100">
                            <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'DiscountsRecord', params: {id: props.row.id} }">Bekijken</b-button>
                        </b-table-column>
                    </template>

                    <template #empty>
                        <section class="section">
                            <div class="content has-text-grey has-text-centered">
                                <p class="margin0" v-if="loading === false">Geen kortingen gevonden.</p>
                                <p class="margin0" v-else>Laden...</p>
                            </div>
                        </section>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>

<script>
import PageTitle from '../PageTitle.vue'
import filtersMixin from '@/mixins/filterMixins'
import axios from 'axios';
import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'DiscountsOverview',

    components: {
        PageTitle
    },

    mixins: [filtersMixin, paramsMixin],

    data() {
        return {
            records: [],
            loading: false,
            total: 0,
            page: 1,
            perPage: 20,
            sortField: 'updated_at',
            sortOrder: 'desc',
            searchParams: _.has(this.$store.state.searchQueries, ['DiscountsOverview']) ? this.$store.state.searchQueries['DiscountsOverview'] : null,
            filters: {},
        };
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        paginated(){
            return this.records.length < this.total
        }
    },


    mounted() {
        this.loadAsyncData()
    },

    methods: {
        async loadAsyncData() {
            this.loading = true

            // Set filter params & admin params
            let params = this.setParams(this.searchParams, `DiscountsOverview`)

            if (Object.keys(this.filters).length) {
                params += `&${Object.keys(this.filters).join('&')}`
            }

            axios.get(`/api/discounts?${params}`, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.records = response.data.data
                this.total = response.data.total

                // Load usage counts
                for (const discount of this.records) {
                    axios.get(`/api/discounts/${discount.id}`, { headers: {'Authorization': 'bearer ' + this.$store.state.authToken} }).then((countResponse) => {
                        discount.contract_product_discounts_count = countResponse.data.contract_product_discounts_count || 0
                    })
                }

                this.$store.dispatch('setSearchQuery', {type: `DiscountsOverview`, query: params})
            }).catch((error) => {
                this.$buefy.toast.open({
                    message: 'Fout bij ophalen van kortingen',
                    type: 'is-danger'
                });
                console.error('Error loading discounts:', error)
            }).then(() => {
                this.loading = false
                this.searchParams = null
            })
        },

        onPageChange(page) {
            this.page = page
            this.loadAsyncData()
        },

        onSort(field, order) {
            this.sortField = field
            this.sortOrder = order
            this.loadAsyncData()
        },

        async toggleActive(discount) {
            try {
                const headers = { 'Authorization': 'bearer ' + this.$store.state.authToken }
                const response = await axios.post(`/api/discounts/${discount.id}/toggle-active`, {}, { headers })
                discount.active = !discount.active

                if (response.data.success) {
                    this.$buefy.toast.open({
                        message: response.data.success,
                        type: 'is-success'
                    })
                }
            } catch (error) {
                this.$buefy.toast.open({
                    message: 'Fout bij wijzigen status',
                    type: 'is-danger'
                })
            }
        },


        getDiscountDisplay(discount) {
            if (discount.type === 'percentage') {
                return `${discount.value}%`
            }

            return `€${Number(discount.value).toFixed(2).replace('.', ',')}`
        }
    }
};
</script>
